import styled from 'styled-components'

import { inputgray, gold } from '../../styles/colors'

export const StyledLink = styled.div`
  a {
    color: ${inputgray};
    font-weight: 300;

    &:hover {
      color: ${gold};
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Module/styles.js